module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_4-ff39e6122d73590b0a38e74144bd7d80.jpg";